<template>
  <div class="formCom">
    <div class="form">
      <div class="kit-id">
        Kit ID {{ this.KitInfo.kit_id }}
      </div>
      <div class="kit-id delete">
        Delete?
      </div>
      <div class="button-wrap">
        <button class="btn" @click="closeConfurmModal">
          <CloseIcone></CloseIcone>
        </button>
        <button class="btn" @click="remove">
          <img src="../../images/dashboard/done.png" alt="#" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CloseIcone from "../../images/shared/cancel";

export default {
  props: ["KitInfo"],
  components: {
    CloseIcone
  },
  methods: {
    ...mapActions(["removeKit", "getAdminInfoList"]),
    closeConfurmModal() {
      this.$emit("closeConfurmModalKit", false);
    },
    remove() {
      this.removeKit(this.KitInfo.id).then(res => {
        this.getAdminInfoList().then(res => {
          this.$emit("closeConfurmModalKit", false);
        });
      });
    }
  }
};
</script>

<style scoped>
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.form {
  padding: 30px;
  background-color: #fff;
  max-width: 350px;
  width: 100%;
  position: relative;
  z-index: 1;
}
.button-wrap {
  width: 80%;
  margin: 0 auto 15px auto;
  display: flex;
  justify-content: space-around;
}
.kit-id {
  color: #005eb8;
  font-size: 24px;
  margin: 0 0 10px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.kit-id.delete {
  margin: 0 0 15px 0;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 1px solid transparent;
  cursor: pointer;
}
.btn img {
  max-width: 100%;
  height: 100%;
}
</style>
